import React, {PropsWithChildren} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../../constants/typography';
import {ImageIcon} from '../../../../atoms/Image/ImageIcon';
import {Text} from '../../../../atoms/Text/Text';
import {Toggle} from '../../../../atoms/Toggle/Toggle';

export interface Props {
  active: boolean;
  label: string;
  sublabel?: string;
  className?: string;
  onToggle: () => void;
}

export const FilterFlyoutBoolean: React.FC<
  Props & FilterFlyoutBooleanWithIconProps
> = ({active, label, onToggle, className, icon, sublabel}) => {
  return (
    <Section data-testid="filterFlyoutSectionBoolean" className={className}>
      <Wrapper>
        <TextWrapper>
          <FilterFlyoutBooleanWithIcon icon={icon}>
            <Label>{label}</Label>
          </FilterFlyoutBooleanWithIcon>
          {sublabel && <Text color="Grey1">{sublabel}</Text>}
        </TextWrapper>
        <Toggle checked={active} onChange={onToggle} aria-label={label} />
      </Wrapper>
    </Section>
  );
};

interface FilterFlyoutBooleanWithIconProps {
  icon?: {
    description: string;
    url: string;
    aspectRatio?: {height?: number; width?: number};
  };
}

const FilterFlyoutBooleanWithIcon: React.FC<
  PropsWithChildren<FilterFlyoutBooleanWithIconProps>
> = ({icon, children}) => {
  if (!icon) {
    return <>{children}</>;
  }

  return (
    <IconLabelWrapper>
      <ImageIcon url={icon.url} description={icon.description} />
      {children}
    </IconLabelWrapper>
  );
};

const IconLabelWrapper = styled.div`
  align-items: center;
  display: flex;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Section = styled.div`
  width: 100%;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Label = styled.label`
  font-size: ${FONT_SIZES.px16};
  font-weight: ${FONT_WEIGHTS.bold};
  color: ${COLORS.Black};
`;
